export const WS_TYPE_UNIGIS = 'unigis';
export const WS_TYPE_RECURSO_CONFIABLE = 'recursoConfiable';
export const WS_TYPE_WEBHOOK = 'webhook';
export const WS_TYPE_LITE_QUALITAS = 'redesLiteQualitas';

export const WS_TYPE = {
  [WS_TYPE_UNIGIS]: 'Unigis',
  [WS_TYPE_RECURSO_CONFIABLE]: 'Recurso confiable',
  [WS_TYPE_WEBHOOK]: 'Webhook',
  [WS_TYPE_LITE_QUALITAS]: 'Redes Lite Quálitas',
};

export type WsType =
  | typeof WS_TYPE_RECURSO_CONFIABLE
  | typeof WS_TYPE_UNIGIS
  | typeof WS_TYPE_WEBHOOK
  | typeof WS_TYPE_LITE_QUALITAS;

export const wsTypeOptions = ({ isFilter = false, required = false }) => {
  const options: Array<{ id?: string; label: string }> = [
    ...Object.entries(WS_TYPE).map(([key, wsType]) => ({
      id: key,
      label: wsType,
    })),
  ];
  if (!required) {
    options.unshift({
      id: undefined,
      label: isFilter ? 'Todos' : 'Ninguno',
    });
  }
  return options;
};
